export var single = [
    {
      "name": "Municipal",
      "value": 8940000
    },
    {
      "name": "Part. Subv",
      "value": 5000000
    },
    {
      "name": "Particular",
      "value": 7200000
    }
  ];
  
  export var multi = [
    {
      "name": "Municipal",
      "series": [
        {
          "name": "2017",
          "value": 7300000
        },
        {
          "name": "2018",
          "value": 8940000
        }
      ]
    },
  
    {
      "name": "Part. Subv",
      "series": [
        {
          "name": "2017",
          "value": 7870000
        },
        {
          "name": "2018",
          "value": 8270000
        }
      ]
    },
  
    {
      "name": "Particular",
      "series": [
        {
          "name": "2017",
          "value": 5000002
        },
        {
          "name": "2018",
          "value": 5800000
        }
      ]
    }
  ];
  


// WEBPACK FOOTER //
// ./src/app/interfaces/data.ts